export interface IOrderOptions {
  label: string;
  description?: string;
  url: string;
  icon?: any;
}

import { useAppSelector } from "hooks/redux";
import { useTranslation, Trans } from "react-i18next";
export default function SettingOptionsTranslation() {
  const { t, i18n } = useTranslation();
  const { facilityStore } = useAppSelector(store => store);

  const orderOptions = [
    {
      label: t("secure.facility.order.order_options.001"),
      description: t("secure.facility.order.order_options.004"),
      url: "/admin/order",
    },
    {
      label: t("secure.facility.order.order_options.002"),
      description: t("secure.facility.order.order_options.005"),
      url: "/admin/rainchecks",
    },
    {
      label: t("secure.facility.order.order_options.003"),
      description: t("secure.facility.order.order_options.006"),
      url: "/admin/giftcards",
    },
    {
      label: t("secure.facility.order.order_options.007"),
      description: t("secure.facility.order.order_options.008"),
      url: "/admin/forms",
    },
    {
      label: t("secure.facility.order.order_options.009"),
      description: t("secure.facility.order.order_options.010"),
      url: "/admin/invoices",
    },
    {
      label: t("secure.facility.order.order_options.011"),
      description: t("secure.facility.order.order_options.012"),
      url: "/admin/invoices/deposits",
    },
    ...(facilityStore?.facility?.module_food_ordering ? [
      {
        label: t("Food Ordering"),
        url: "/admin/food-ordering/overview",

        subOptions: [
          {
            label: t("Overview"),
            url: "/admin/food-ordering/overview",
          },
          {
            label: t("Order Display"),
            url: "/admin/food-ordering/display",
          },
        ],
      },
    ] : []),
  ];

  return orderOptions;
}
